function calculateOpexCapex(graph) {
        let allEquipment = graph.getElements()
        //add together all element
        /*if(){
            let allEquipment = graph.getElements()
            console.log(allEquipment)
        }*/
        //initialise the sum arrrays
        let opexSum = 0
        let capexSum = 0
        let feedCostSum = 0
        let productCostSum = 0
        const capexArrayOG = []
        const opexArrayOG = []
        const equipNameArray = []
        const equipArray = []
        let dutySum = 0

        for (let i = 0; i < allEquipment.length; i++) {
            let streamsList = graph.getLinks()
            if (allEquipment[i].prop("isUnit") == "yes") {
                if (allEquipment[i].attributes['equipment_Properties']['unitType'] == 'feed' || allEquipment[i].attributes['equipment_Properties']['unitType'] == 'Feed') {
                    if ((allEquipment[i].attributes['equipment_Economics']) && (allEquipment[i].attributes['equipment_Economics']['Cost'])) {

                        let feedCost = parseFloat(allEquipment[i].attributes['equipment_Economics']['Cost']['Value'])
                        //outputStream = allEquipment[i].getConnectedLinks() //this should only return a list of 1 because it's feed or product
                        let outputStream = graph.getConnectedLinks(allEquipment[i])
                        // console.log(outputStream)
                        //var links = graph.getConnectedLinks(element);
                        let streamEP = this.calculateFeedEP(graph, allEquipment[i])
                        if (streamEP == null || isNaN(streamEP) | streamEP === undefined) {
                            throw new Error("Specify a Total Flow for all Feed Streams.")
                        }
                        feedCostSum += streamEP

                    }
                    else {
                        //feedCostSum += 0 //if it doesn't exist, don't add anything
                    }
                }
                else if (allEquipment[i].attributes['equipment_Properties']['unitType'] == 'product' || allEquipment[i].attributes['equipment_Properties']['unitType'] == 'Product') {
                    if ((allEquipment[i].attributes['equipment_Economics']) && (allEquipment[i].attributes['equipment_Economics']['Cost'])) {
                        //productCostSum += parseInt(allEquipment[i].attributes['equipment_Economics']['Cost']['Value'])
                        let prodCost = parseFloat(allEquipment[i].attributes['equipment_Economics']['Cost']['Value'])
                        //inputStream = allEquipment[i].getConnectedLinks() //this should only return a list of 1 because it's feed or product
                        let inputStream = graph.getConnectedLinks(allEquipment[i])
                        let totalFlow = inputStream[0].attributes['complete_Stream_Properties']['totalFlow'] //total flow is in kg
                        let streamEP = totalFlow * prodCost
                        productCostSum += streamEP
                    }
                    else {
                        //productCostSum += 0  do nothing
                    }
                }
                else {
                    if (allEquipment[i].attributes['equipment_Economics']) {
                        capexSum += parseFloat(allEquipment[i].attributes['equipment_Economics']['Capex']['Value'])
                        //marry the array with names using the
                        //capexArrayOG.push(allEquipment[i].attributes['equipment_Economics']['Capex'][''])
                        //capexArrayOG.push(allEquipment[i].attributes['equipment_Economics']['Opex'][''])
                        equipNameArray.push(allEquipment[i].attributes['unit_Label'])
                        capexArrayOG.push(allEquipment[i].attributes['equipment_Economics']['Capex']['Value'])
                        opexArrayOG.push(allEquipment[i].attributes['equipment_Economics']['Opex']['Value'])

                        if (allEquipment[i].attributes['equipment_Economics']['Duty']) {
                            dutySum += parseFloat(allEquipment[i].attributes['equipment_Economics']['Duty']['Value'])
                            
                            // If OPEX exists and is different from duty*elecCost calculation, it's probably API-calculated
                            const dutyBasedOpex = parseFloat(allEquipment[i].attributes['equipment_Economics']['Duty']['Value']) * (this.econVars.elecCost / 1000) * 8000;
                            const actualOpex = parseFloat(allEquipment[i].attributes['equipment_Economics']['Opex']['Value']);
                            
                            if (allEquipment[i].attributes['equipment_Economics']['Opex']['isApiCalculated']) {
                                opexSum += actualOpex; // Add the API-calculated OPEX
                            }
                            else {
                                opexSum += dutyBasedOpex; // Add the OPEX based on duty calculation
                            }
                        } else {
                            opexSum += parseFloat(allEquipment[i].attributes['equipment_Economics']['Opex']['Value'])
                        }

                        equipArray.push(equipNameArray, capexArrayOG, opexArrayOG)
                        console.log(equipNameArray, capexArrayOG)
                    }
                    else {
                        opexSum += 0
                        capexSum += 0
                    }
                }
            }
        }

        //console.log(dutySum)
        //console.log(opexSum)
        return [opexSum, capexSum, feedCostSum, productCostSum, dutySum]
    }

    export default calculateOpexCapex